﻿﻿export interface ICenterSummary {
    id: number;
    alias: string;
    name: string;
    dcnDomain: string;
    nkrLiaison: string;
    isNkrParticipant: boolean;
    isDcnParticipant: boolean;
    isDashParticipant: boolean;
    isInListingService: boolean;
    isInRemoteDonation: boolean;
    isPrivate: boolean;
    isDeleted: boolean;
    isAcceptingReferrals: number;
    nddReferrals: boolean;
    excludeDataCompliance: number;
    isAllIn: number;
    isGoldStar: boolean;
    hasAgreementFile: number;
    isAdpParticipant: boolean;
    isFamilyVoucherParticipant: boolean;
    isAdpPartner: number;
    isInDonorShield: boolean;
    transplantsLast12Months: number;
    annualFee: number;
    monthlyFee: number;
    hasAgreedToFees: number;
    acceptsVxms: boolean;
    isFollowUpParticipant: boolean;
    isPwlUser: boolean;
    isMicrositeParticipant: boolean;
    earliestPickupTime: string;
    latestDropoffTime: string;
}
